import * as React from 'react';
import i18next from 'i18next';

import getNavigatorLanguage from './utils/getBrowserLanguage';

const LANGUAGE_CODES = [
  'en',
  'nl',
  'fr',
  'it',
  'de',
  'da',
  'sq',
  'hy',
  'az',
  'eu',
  'be',
  'bs',
  'bg',
  'ca',
  'co',
  'hr',
  'cs',
  'et',
  'fi',
  'fy',
  'gl',
  'el',
  'hu',
  'is',
  'ga',
  'lv',
  'lt',
  'lb',
  'mk',
  'mt',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'gd',
  'sr',
  'sk',
  'sl',
  'es',
  'sv',
  'tr',
  'uk',
  'cy',
  'af',
] as const;

type LanguageCode = (typeof LANGUAGE_CODES)[number];

const loadTranslations = () => {
  const modules = import.meta.glob('./data/*.json', { eager: true }) as Record<string, { default: any }>;
  const translations: Partial<Record<LanguageCode, any>> = {};

  for (const code of LANGUAGE_CODES) {
    const mod = modules[`./data/${code}.json`];
    if (mod) {
      translations[code] = mod.default;
    }
  }

  return translations;
};

const supportedLanguages = loadTranslations();

const deviceLanguage = getNavigatorLanguage();

const DEFAULT_LANGUAGE = 'en';

export const getCurrentLanguage = () => {
  if (!deviceLanguage) {
    return DEFAULT_LANGUAGE;
  }
  if (supportedLanguages[deviceLanguage as LanguageCode]) {
    return deviceLanguage;
  }
  const languagekey = deviceLanguage.split('-')[0];
  if (supportedLanguages[languagekey as LanguageCode]) {
    return languagekey;
  }
  return DEFAULT_LANGUAGE;
};

const resources: Record<string, { translation: any }> = {};
for (const [code, data] of Object.entries(supportedLanguages)) {
  resources[code] = { translation: data };
}

i18next.init({
  resources,
  lng: getCurrentLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});

export const t = (key: string, properties?: any): string => {
  let translation = i18next.t(key, properties) as string;
  translation = translation.replace(/\<\/?b\>/gi, '').replace(/\<\/?strong\>/gi, '');
  return translation;
};
export const tHtml = (key: string, properties?: any): any => {
  return <span dangerouslySetInnerHTML={{ __html: i18next.t(key, properties) }} />;
};
export default i18next;
